import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { filter, Observable, Subject, switchMap, takeUntil,merge } from 'rxjs';
import { InventoryService } from 'src/app/services/inventory.service';
import { HeaderService } from '../../header/header.service';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { VendorTypeAhead } from 'src/app/models/inventory.model';

@Component({
  selector: 'app-create-quick-product-dialog',
  templateUrl: './create-quick-product-dialog.component.html',
  styleUrl: './create-quick-product-dialog.component.scss'
})
export class CreateQuickProductDialogComponent implements OnInit, OnDestroy{
  private destroy$ = new Subject<void>();
  radioOption: FormControl = new FormControl("SKU");
  spin: boolean=false;
  totalCount:any;
  form: FormGroup = new FormGroup({
    vendor: new FormControl('', [Validators.required]),
    radioOption: new FormControl("", [Validators.required])
  });
  filteredOptions$: Observable<VendorTypeAhead[]>;
  filterModel: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CreateQuickProductDialogComponent>,
    private inventoryService:InventoryService,
    private snackBar:MatSnackBar,
    private headerService:HeaderService
  ){
    this.headerService.remoteActionBroadcaster.pipe(takeUntil(this.destroy$),
    filter((e) => e.action === "CreateQuickProduct"))
    .subscribe((e) => {
      if(e.response && e.response?.responseType === 'success'){
        this.spin = false;
        let msg
        if(e.response.message?.length > 0){
           msg = e.response.message.map(item => item.value).join(', ');
        }          
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: msg ? msg + ' ' + 'Already mapped' : 'Create Quick Product Updated Successfully',
              action: 'Dismiss',
              type: msg ? 'error' : 'success',
            },
          }
        );
        this.dialogRef.close(true);
      }else if(e.response && e.response?.responseType == "error"){
        this.spin = false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: e?.response?.message, 
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
        this.dialogRef.close(true);
       }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  ngOnInit(): void {
    this.totalCount=this.data.totalCount;
    this.filterModel=this.data.filterModel;   
    const initialOptions$ = this.inventoryService.typeaheadVendor('');
    this.filteredOptions$ = merge(
      initialOptions$,
      this.form.get("vendor").valueChanges.pipe(
        filter(e => typeof e === 'string'),
        switchMap((value) => this.inventoryService.typeaheadVendor(value))
      )
    );
  }

  action(e) {
    if (e === "Create") {
      this.createProduct(this.data.filterModel)
    } else {
      this.close();
    }
  }

  close(){
    this.dialogRef.close();
  }

  createProduct(filterModel){
    this.spin = true;
    const payload = {
      type:this.form.get('radioOption').value,
      vendorId:this.form.get('vendor')?.value?.vendorId,
    }
    const body:any ={
      filterModel
    }
    this.inventoryService.createQuickProduct(body,this.data.columnsDef,this.data.search,payload).subscribe({
      next:(res:any)=>{
      },
      error:(err)=>{
        this.spin = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 4000,
          horizontalPosition: "center",
          data: {
            title: err.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
      }
    })
  }

  setVendor(items, name): void {
    const item = items.find(
      (res) => res.name.toLowerCase() === name.toLowerCase()
    );
    if (item) {
      this.form.patchValue({ vendor: item }, { emitEvent: false });
    }
  }

  displayWith(value: any) {
    if (value) {
      return value.name;
    }
  }
}
